import { AppRoutePath } from 'Pages/routes';
import Link from 'next/link';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

type NoMoreTimeSlotsAlertProps = {
  dateUnix: number | undefined;
  link?: string;
  copy: string;
}

const NoMoreTimeSlotsAlert: React.FC<NoMoreTimeSlotsAlertProps> = ({
  dateUnix,
  link,
  copy,
}) => {
  return (
    <div>
      <span>
        {copy}{
          dateUnix ? ` for ${dayjs.unix(dateUnix).format('LL')}` : ''
        }.{' '}<br />
      </span>
      <Link href={link || AppRoutePath.BROWSE_SERVICE_TYPES} className="link font-bold underline">
        Please try another date.
      </Link>
    </div>
  );
};

export default NoMoreTimeSlotsAlert;
